// @file Registers the <pdlt-mention> custom element.
import { MENTION_ELEMENT_TAG_NAME, PdltMention } from '@padlet/universal-post-editor'

window.customElements.define(MENTION_ELEMENT_TAG_NAME, PdltMention)
